import { useFormikContext } from 'formik';
import React, { FC, useState } from 'react';
import { DEF_PG_SIZE_SUB } from '../../constants/maximum-page-size';

import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from '../../contexts/table/TableContextProvider';
import { TranslationKeys } from "../../contexts/TranslationKeys";
import PresetOutputModeColumns from '../../models/ColumnDefinitions/PresetOutputModeColumns';
import PresetOutputModeSearch from '../../models/search/PresetOutputModeSearch';
import { getModesWithPagination, updatePreset } from '../../services/presetOutputService';
import { getErrorMessage } from '../../services/utilities/ServiceError';
import ActivityFrame from '../activity-frame/activity-frame';
import { useDialog } from '../dialog/DialogContext';
import TableTab from "../tabs/table-tab";
import { toast } from "react-toastify";
import { PresetOutputWizard } from './presetOutputWizard/presetOutputWizard';
import { getListQueryForOutputModeIds} from "../../utilities/modeTypeUtils";

interface Props {
    itemId: string;
}

const PresetOutputs: FC<Props> = ({ itemId }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.mode);
    const [showModal, setShowModal] = useState(false);
    const [busy, setBusy] = useState(false);
    const [presetOutputId, setPresetOutputId] = useState('');
    const dialog = useDialog();
    const { values } = useFormikContext<any>();

    const handleSave = (formFields) => {
        updatePreset(formFields)
            .then(success => {
                toast.success(translate.byKey(TranslationKeys.presetSaved));
            })
            .catch(failure => {
                dialog.pushError({ title: translate.byKey(TranslationKeys.error), message: getErrorMessage(failure) })
            });
        setPresetOutputId('');
    }

    const editPresetOutput = async (id: string) => {
        setPresetOutputId(id);
        setShowModal(true);
    }

    return <>
        <ActivityFrame busy={busy} className='flex flex-col flex-grow bg-white'>
            <TableContextProvider
                usePagination
                useTable
                useSort
                useSearch
                useFilter
                editMethod={editPresetOutput}
                dataMethod={(listQuery) => getModesWithPagination(getListQueryForOutputModeIds(values.pSysnameType,listQuery))}
                tableDescriptor={PresetOutputModeColumns}
                searchDescriptor={PresetOutputModeSearch}
                maxPageSize={DEF_PG_SIZE_SUB}>
                <TableTab
                    title={title}
                    selectRows={false}
                    cyName='presetOutputs'>
                    <PresetOutputWizard
                        isOpen={showModal}
                        onClose={() => {
                            setPresetOutputId('');
                            setShowModal(false);
                        }}
                        title={translate.byKey(TranslationKeys.editOutputsForMode)}
                        presetId={presetOutputId}
                        profileId={itemId}
                        onSave={handleSave}>
                    </PresetOutputWizard>
                </TableTab>
            </TableContextProvider>
        </ActivityFrame>
    </>
};

export default PresetOutputs;
